var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4286 1.71436C19.4911 1.71436 20.3996 2.09159 21.1541 2.84605C21.9086 3.60052 22.2858 4.509 22.2858 5.5715V18.4286C22.2858 19.4911 21.9086 20.3996 21.1541 21.1541C20.3996 21.9086 19.4911 22.2858 18.4286 22.2858H15.9108V14.317H18.576L18.9777 11.2099H15.9108V9.22775C15.9108 8.72775 16.0157 8.35275 16.2255 8.10275C16.4353 7.85275 16.8438 7.72775 17.451 7.72775L19.0849 7.71436V4.94203C18.5224 4.86168 17.7277 4.8215 16.701 4.8215C15.4867 4.8215 14.5157 5.17864 13.788 5.89293C13.0603 6.60721 12.6965 7.61614 12.6965 8.91971V11.2099H10.0179V14.317H12.6965V22.2858H5.5715C4.509 22.2858 3.60052 21.9086 2.84605 21.1541C2.09159 20.3996 1.71436 19.4911 1.71436 18.4286V5.5715C1.71436 4.509 2.09159 3.60052 2.84605 2.84605C3.60052 2.09159 4.509 1.71436 5.5715 1.71436H18.4286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cab52c2e6469fdc8ca442ef33e4f95cc.svg";
export { ForwardRef as ReactComponent };